<template>
 <div class="row">
    <div class="col-md-12 card">
        <div class="card-header">
          <div class="row">
              <div class="col-md-6">
                <h5 class="title">Reports <span style="color: #FDCB6A">|</span>Soil Map</h5>
              </div>
              <div class="col-md-3">
                <fg-input>
                  <el-select size="large" @change="filterMapData()" class="select-primary" v-model="country" filterable clearable placeholder="Select Country">
                      <el-option
                        class="select-primary"
                        v-for="country in Countries"
                        :key="country.id"
                        :label="country.name"
                        :value="country.name"></el-option>
                  </el-select>
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input>
                    <el-select size="large" @change="filterMapData()" class="select-primary" v-model="ngo" value-key="0" filterable clearable placeholder="Select NGO">
                        <el-option
                          class="select-primary"
                          v-for="ngo in NGO"
                          :key="ngo.id"
                          :label="ngo.name"
                          :value="ngo.name"></el-option>
                    </el-select>
                </fg-input>
              </div>
          </div>
        </div>
        <hr>
        <div class="card-body" style="margin:-20px">
          <div id="regularMap" class="map"></div>
        </div>
    </div>
</div>

</template>
<script>
  import {API_KEY} from './API_KEY'
  import GoogleMapsLoader from 'google-maps'
  GoogleMapsLoader.KEY = API_KEY;
  import Resource from "@/util/Api/resource.js";
  const NGOResources = new Resource("category/childrenGivenParent");
  const postResource = new Resource("post");

  export default {
    data() {
      return {
        soilScanMapData:[],
        postCoordinate:[],
        locations:[],
        mapData:[],
        NGO:[],
        Countries:[],
        ngo:'',
        country:'',
        post:{
          FieldName:'',
          Link:'',
          Ngo:'',
          Country:'',
          Community:'',
          Name:'',
          Longitude:0,
          Latitude:0,
        },
      }
    },


  methods: {

     // Get all countries in a category
    async getCountry() {
      await NGOResources.get(2).then(response => {
        this.Countries = response.data;
      }).catch(error => {
         console.log('Failed getting all country data')
      });
    },

    // Get all NGOs in a categories
    async getNGOs() {
      await NGOResources.get(1).then(response => {
        this.NGO = response.data;
      }).catch(error => {
         console.log('Failed getting NGO data')
      });
    },


    // get coordinates from post endpoint
    async getPostCoordinate(){
      await postResource.list({})
      .then((response) => {
        let data = response.data;

        //console.log('Data', response.data);

        data.forEach((element) => {

            if(element.post.title.includes('Saved_Link')){

               let postContent = element.postContent;
               this.post = [];

               //console.log('content', postContent);

                postContent.forEach((value, index) => {

                    if(index === 0){
                        if(value.Answer){
                           this.post.FieldName = JSON.parse(value.Answer);
                        } else {
                           this.post.FieldName = "";
                        }
                    }

                    if(index === 1){
                        if(value.Answer){
                           this.post.Link = JSON.parse(value.Answer);
                        } else {
                           this.post.Link = "";
                        }
                    }

                    if(index === 2){
                        if(value.Answer){
                           this.post.Ngo = JSON.parse(value.Answer);
                        } else {
                           this.post.Ngo = "";
                        }
                    }

                    if(index === 3){
                        if(value.Answer){
                           this.post.Country = JSON.parse(value.Answer);
                        } else {
                           this.post.Country = "";
                        }
                    }

                    if(index === 4){
                        if(value.Answer){
                           this.post.Community = JSON.parse(value.Answer);
                        } else {
                           this.post.Community = "";
                        }
                    }

                    if(index === 5){
                        if(value.Answer){
                           this.post.Name = JSON.parse(value.Answer);
                        } else {
                           this.post.Name = "";
                        }
                    }

                    if(index === 6){
                        if(value.Answer){
                           this.post.Longitude = JSON.parse(value.Answer);
                        } else {
                           this.post.Longitude = "";
                        }
                    }

                    if(index === 7){
                        if(value.Answer){
                           this.post.Latitude = JSON.parse(value.Answer);
                        } else {
                           this.post.Latitude = "";
                        }
                    }

                });

                this.locations.push(this.post);
            }
        });


        this.locations.forEach((element) => {
           if(element.Longitude && element.Latitude){
              this.mapData.push(element);
           }
        });

        //console.log('Locations', this.locations);

        this.filterMapData();

      }).catch(() => {
         console.log(`An error occured getting field data ${error}`);
      });
    },

    // filter map data
    filterMapData(){
        this.soilScanMapData = this.filterData;
       // console.log('Map Data', this.soilScanMapData);
        GoogleMapsLoader.load((google) => {
          this.initRegularMap(google)
        });
    },

    // function to show map
    initRegularMap (google) {

          let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

          let map = new window.google.maps.Map(document.getElementById('regularMap'), {
            zoom: 3,
            center: new window.google.maps.LatLng(0, 0),
            scrollwheel: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          });

          let infowindow = new window.google.maps.InfoWindow();

          let markerBg = {
              url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
              size: new google.maps.Size(80, 30),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(0, 32)
          };

          let marker;
          let clusterMarkers = [];

          if(this.soilScanMapData.length > 0) {
              this.soilScanMapData.forEach((element, index) => {

                marker = new window.google.maps.Marker({
                  position: new window.google.maps.LatLng(element.Longitude, element.Latitude),
                  map: map,
                  label:labels[index % labels.length],
                  title:element.FieldName.toUpperCase(),
                  animation: google.maps.Animation.DROP,
                  icon: markerBg,
                });

                google.maps.event.addListener(marker, 'click', ((marker, index) => {
                  return () => {
                    infowindow.setContent("Field Name: " + element.FieldName.toUpperCase() +
                    "<br> Farmer: " + element.Name +
                    "<br> Ngo: " + element.Ngo +
                    "<br> Country: " + element.Country +
                    "<br> Community: " + element.Community);
                    infowindow.open(map, marker);
                  }
                })(marker, index));

                clusterMarkers.push(marker);

              });
        }

        let mcOptions = {
          styles:[{
            url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
            width: 50,
            height:50,
            fontFamily:"comic sans ms",
            textColor:"white",
            anchorText:[20,1],
          }]
        };

        let mc = new MarkerClusterer(map, clusterMarkers, mcOptions);

    },

  },

  mounted () {
    this.getNGOs();
    this.getCountry();
    this.getPostCoordinate();
  },

  computed: {

    filterData() {
      let result = this.mapData;
      if (this.country) {
        result = result.filter((row) => {
            return Object.keys(row).some((key) => {
                return (String(row[key]).toLowerCase().indexOf(this.country.toLowerCase()) > -1);
            })
        });
      } else if(this.ngo){
        result = result.filter((row) => {
            return Object.keys(row).some((key) => {
                return (String(row[key]).toLowerCase().indexOf(this.ngo.toLowerCase()) > -1);
            })
        });
      }

      return result;
    }


  }

}

</script>
<style>
  #map {
    height: 100%;
  }
</style>
